module.exports = __webpack_public_path__ + "static/media/029-Crazy Cactus.ba8c217f.png";